import Header from "@/components/enfinity/our-solutions/enfinipay/Header";
import OurFeatures from "@/components/enfinity/our-solutions/enfinipay/OurFeatures";
import DailyPay from "@/components/enfinity/our-solutions/enfinipay/DailyPay";
import MultipleWays from "@/components/enfinity/our-solutions/enfinipay/MultipleWays";
import GetMoney from "@/components/enfinity/our-solutions/enfinipay/GetMoney";
import Crypto from "@/components/enfinity/our-solutions/enfinipay/Crypto";
import SimpleProcess from "@/components/enfinity/our-solutions/enfinipay/SimpleProcess";
import CTA from "@/components/enfinity/CTA";
import FAQ from "@/components/enfinity/Faq";
import Footer from "@/components/enfinity/Footer";
import scrollTo from "@/utils/scrollTo";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function EnfiniPay() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scrollTo(location.state.scrollTo);
        navigate(location.pathname, { replace: true, state: {} });
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location, navigate]);

  return (
    <div className="bg-[#111111]">
      <Header />

      <OurFeatures />

      <DailyPay />

      <MultipleWays />

      <GetMoney />

      <Crypto />

      <SimpleProcess />

      <div>
        <CTA />
      </div>

      <div className="min-h-[900px] bg-white lg:pb-36 xxs:pb-60">
        <FAQ />
      </div>

      <Footer />
    </div>
  );
}

